/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1QuoteLinesCreatePathParameters,
  BillingV1QuoteLinesDestroyPathParameters,
  BillingV1QuoteLinesListParams,
  BillingV1QuoteLinesListPathParameters,
  BillingV1QuoteLinesPartialUpdatePathParameters,
  BillingV1QuoteLinesRetrievePathParameters,
  CursorPaginatedQuoteLineResponseV1,
  PatchedQuoteLineUpdateRequestV1Request,
  QuoteLineCreateRequestV1Request,
  QuoteLineResponseV1,
  QuoteResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingQuoteLineService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. Ordered by creation (id ASC). `?section=` keeps one section; absent, both.
 * @summary List the lines of a quote, of both sections or of one.
 */
 billingV1QuoteLinesList<TData = CursorPaginatedQuoteLineResponseV1>(pathParams: BillingV1QuoteLinesListPathParameters,
    params?: BillingV1QuoteLinesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteLinesList<TData = CursorPaginatedQuoteLineResponseV1>(pathParams: BillingV1QuoteLinesListPathParameters,
    params?: BillingV1QuoteLinesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteLinesList<TData = CursorPaginatedQuoteLineResponseV1>(pathParams: BillingV1QuoteLinesListPathParameters,
    params?: BillingV1QuoteLinesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteLinesList<TData = CursorPaginatedQuoteLineResponseV1>(
    { identity }: BillingV1QuoteLinesListPathParameters,
    params?: BillingV1QuoteLinesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. Each line names its `section` (`installation` or `service`), so one request can add lines to both; the two are priced alike (sale price, discount, margin). `lines` takes one or more lines (up to its `maxItems`), and they go in in one transaction: if one fails, none is added, and the error names that line in `field` (`lines.<i>.<field>`, or `lines.<i>` when the whole line is to blame), like `errors[].field` of a validation error. A line that repeats a BillingItem, a work and a section already on the quote, or another line of the same request, is one more line: quantities are not merged. A work takes any number of lines. Omit `catchment_work` when the quote has exactly one work. Omit `unit_cost` and `unit_price` to copy the catalog cost and sale price. The response is the quote with its totals rolled up again.
 * @summary Add one or more lines to a quote.
 */
 billingV1QuoteLinesCreate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteLinesCreatePathParameters,
    quoteLineCreateRequestV1Request: QuoteLineCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteLinesCreate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteLinesCreatePathParameters,
    quoteLineCreateRequestV1Request: QuoteLineCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteLinesCreate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteLinesCreatePathParameters,
    quoteLineCreateRequestV1Request: QuoteLineCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteLinesCreate<TData = QuoteResponseV1>(
    { identity }: BillingV1QuoteLinesCreatePathParameters,
    quoteLineCreateRequestV1Request: QuoteLineCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/lines/`,
      quoteLineCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/lines/`,
      quoteLineCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/lines/`,
      quoteLineCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only.
 * @summary Get one line of a quote.
 */
 billingV1QuoteLinesRetrieve<TData = QuoteLineResponseV1>(pathParams: BillingV1QuoteLinesRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteLinesRetrieve<TData = QuoteLineResponseV1>(pathParams: BillingV1QuoteLinesRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteLinesRetrieve<TData = QuoteLineResponseV1>(pathParams: BillingV1QuoteLinesRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteLinesRetrieve<TData = QuoteLineResponseV1>(
    { identity, lineIdentity }: BillingV1QuoteLinesRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. `billing_item` does not change: that is a new line. `section` moves the line to the other section, with its prices and its note. The line writes its subtotal again. The response is the quote with its totals rolled up again.
 * @summary Partial-update one line of a quote (preserve-on-omit).
 */
 billingV1QuoteLinesPartialUpdate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteLinesPartialUpdatePathParameters,
    patchedQuoteLineUpdateRequestV1Request?: PatchedQuoteLineUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteLinesPartialUpdate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteLinesPartialUpdatePathParameters,
    patchedQuoteLineUpdateRequestV1Request?: PatchedQuoteLineUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteLinesPartialUpdate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteLinesPartialUpdatePathParameters,
    patchedQuoteLineUpdateRequestV1Request?: PatchedQuoteLineUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteLinesPartialUpdate<TData = QuoteResponseV1>(
    { identity, lineIdentity }: BillingV1QuoteLinesPartialUpdatePathParameters,
    patchedQuoteLineUpdateRequestV1Request?: PatchedQuoteLineUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,
      patchedQuoteLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,
      patchedQuoteLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,
      patchedQuoteLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. 204 with no body; read the quote again for its new totals.
 * @summary Remove one line from a quote.
 */
 billingV1QuoteLinesDestroy<TData = void>(pathParams: BillingV1QuoteLinesDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteLinesDestroy<TData = void>(pathParams: BillingV1QuoteLinesDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteLinesDestroy<TData = void>(pathParams: BillingV1QuoteLinesDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteLinesDestroy<TData = void>(
    { identity, lineIdentity }: BillingV1QuoteLinesDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1QuoteLinesListClientResult = NonNullable<CursorPaginatedQuoteLineResponseV1>
export type BillingV1QuoteLinesCreateClientResult = NonNullable<QuoteResponseV1>
export type BillingV1QuoteLinesRetrieveClientResult = NonNullable<QuoteLineResponseV1>
export type BillingV1QuoteLinesPartialUpdateClientResult = NonNullable<QuoteResponseV1>
export type BillingV1QuoteLinesDestroyClientResult = NonNullable<void>
